import InfoDropdown from './InfoDropdown'

export default InfoDropdown
